import '@vtmn/css';
import '@vtmn/icons/dist/vitamix/font/vitamix.css';
import 'sweetalert2/dist/sweetalert2.min.css';

import './style.css';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import i18nConfig from './modules/language/configuration/i18nConfig';






const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

createApp(App)
    .use(pinia)
    .use(router)
    .use(i18nConfig)
    .mount('#app');

